// Paleta determinística de cores por épico — para identificar visualmente as tarefas de um mesmo épico
// no Kanban e no Gantt. Cores arbitrárias por id não cabem em classes Tailwind estáticas, então usamos hex
// inline. Tarefas sem épico usam o tom neutro.

export interface EpicColor {
  /** Cor sólida (borda/acento). */
  solid: string;
  /** Fundo claro para o cabeçalho do grupo. */
  tint: string;
  /** Cor de texto legível sobre o tint. */
  text: string;
}

const PALETTE: EpicColor[] = [
  { solid: "#1466E3", tint: "#e7f0fe", text: "#0b3f9c" }, // brand/azul DataValue
  { solid: "#0ea5e9", tint: "#e0f2fe", text: "#0369a1" }, // azul
  { solid: "#10b981", tint: "#d1fae5", text: "#047857" }, // verde
  { solid: "#f59e0b", tint: "#fef3c7", text: "#b45309" }, // âmbar
  { solid: "#ec4899", tint: "#fce7f3", text: "#be185d" }, // rosa
  { solid: "#8b5cf6", tint: "#ede9fe", text: "#6d28d9" }, // violeta
  { solid: "#14b8a6", tint: "#ccfbf1", text: "#0f766e" }, // teal
  { solid: "#ef4444", tint: "#fee2e2", text: "#b91c1c" }, // vermelho
  { solid: "#f97316", tint: "#ffedd5", text: "#c2410c" }, // laranja
  { solid: "#6366f1", tint: "#e0e7ff", text: "#4338ca" }, // índigo
];

export const NEUTRAL_COLOR: EpicColor = { solid: "#a3aed0", tint: "#f4f7fe", text: "#707eae" };

/** Cor determinística de um épico pelo seu id. `null`/sem épico → neutro. */
export function epicColor(epicId?: number | null): EpicColor {
  if (epicId == null) return NEUTRAL_COLOR;
  const idx = ((epicId % PALETTE.length) + PALETTE.length) % PALETTE.length;
  return PALETTE[idx];
}
